import * as z from "zod";

export const ORIENTATION_API_PREFIX = "/api/orientation";

export const ORIENTATION_API_ERRORS = [
  "method_not_allowed",
  "cross_site",
  "unauthenticated",
  "not_aide",
  "not_session_member",
  "unconfigured",
  "invalid_request",
  "bookmark_not_found",
  "bookmark_revoked",
  "call_not_found",
  "call_not_scheduled",
  "already_enrolled",
  "session_in_progress",
  "session_complete",
  "wrong_phase",
  "consent_not_given",
  "zoom_session_unknown",
  "zoom_session_mismatch",
  "zoom_failed",
  "upstream_failed",
  "not_found",
  "rate_limited",
  "opted_out",
  "invalid_contact",
  "not_deliverable",
  "bookmark_other_reader",
  "early_exit_refused",
  "vocab_layout_not_model_order",
] as const;
export type OrientationApiError = (typeof ORIENTATION_API_ERRORS)[number];

export const orientationApiErrorSchema = z.object({
  error: z.enum(ORIENTATION_API_ERRORS),
});
export type OrientationApiErrorBody = z.infer<typeof orientationApiErrorSchema>;
